import { useEffect } from 'react';

import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

export function useScrollLandingToTop() {
  const { isTabletOrMobile } = useMediaBreakpoints();

  useEffect(() => {
    const container = document.getElementById(LANDING_PAGES_CONTAINER_ID);
    if (container && isTabletOrMobile) {
      setTimeout(() => {
        container.scrollTop = 0;
      }, 100);
    }
  }, [isTabletOrMobile]);
}
